/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Individualizedtopic1Inputs */

const en__field_individualizedtopic1 = /** @type {(inputs: _Field_Individualizedtopic1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`other topics`)
};

const de__field_individualizedtopic1 = /** @type {(inputs: _Field_Individualizedtopic1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`andere Themen`)
};

/**
* | output |
* | --- |
* | "other topics" |
*
* @param {_Field_Individualizedtopic1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_individualizedtopic1 = /** @type {((inputs?: _Field_Individualizedtopic1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Individualizedtopic1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_individualizedtopic1(inputs)
	return de__field_individualizedtopic1(inputs)
});
export { _field_individualizedtopic1 as "_field_individualizedTopic" }